import vehiclePage from "./vehicle-page/store";
export default {

  modules: {
    vehiclePage
  },
};